import React, { useEffect } from "react";
import { useEscapeKey } from "../../utils/useEscapeKey";
const alert = require("./styles/alert.svg");

type Tip = { text: string; link_text?: string; url?: string };
type Prompt = { title: string; text?: string; tip?: Tip };

const DEFAULT_PROMPT: Prompt = {
  title: "Are you sure?",
  text: "This will update the uploading status for all your albums associated with this event."
};

const ConfirmationPopup = ({
  closePopup,
  popupId,
  onSuccess,
  loader,
  eventId
}: {
  closePopup: Function;
  popupId: string | boolean;
  onSuccess: Function;
  loader: boolean;
  eventId?: number;
}) => {
  const [loading, setLoading] = React.useState(false);
  const [prompt, setPrompt] = React.useState<Prompt | null>(
    eventId ? null : DEFAULT_PROMPT
  );
  useEscapeKey(() => closePopup());
  useEffect(() => {
    setLoading(loader);
  }, [loader]);
  useEffect(() => {
    if (!eventId) return;
    $.getJSON(`/api/v1/events/${eventId}/mark_upload_complete_prompt`)
      .then((res: Prompt) => setPrompt(res))
      .fail(() => setPrompt(DEFAULT_PROMPT));
  }, [eventId]);

  const handleConfirm = async () => {
    await $.ajax({
      url: `${popupId}`,
      type: "POST"
    })
      .then((res: any) => {
        onSuccess();
      })
      .fail(() => {
        closePopup();
        //@ts-ignore
        toastr.error("Error updating list. Please try again.");
      });
  };
  return (
    <div>
      <div
        id="filter-dialog"
        className={`modal fade in geo-modal geo-modal--show geo-modal--warning geo-modal--small${eventId ? " muc-confirm" : ""}`}
        style={{ overflow: "unset" }}
        role="dialog"
      >
        <div className="modal-dialog filter-dialog-content">
          <div className="modal-content">
            <div className="modal-header">
              &nbsp;
              <button
                type="button"
                className="close confirm-close"
                onClick={() => closePopup()}
              >
                <span>&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="geo-modal__body">
                <img src={alert} />
                {prompt ? (
                  <>
                    <div className="confirm-heading">{prompt.title}</div>
                    {prompt.text && <p className="confirm-text">{prompt.text}</p>}
                    {prompt.tip && (
                      <p className="confirm-tip">
                        {prompt.tip.text.split("{link}")[0]}
                        {prompt.tip.link_text && <a href={prompt.tip.url}>{prompt.tip.link_text}</a>}
                        {prompt.tip.text.split("{link}")[1]}
                      </p>
                    )}
                  </>
                ) : (
                  <span className="fa fa-spinner fa-spin"></span>
                )}
              </div>
              <div
                className="modal-footer geo-modal__actions dont-break"
                style={{
                  display: "flex",
                  justifyContent: "center"
                }}
              >
                <a
                  className="geo-btn geo-btn--link  geo-btn--caps"
                  onClick={() => closePopup()}
                  style={{ backgroundColor: "#C1C1C1", color: "white" }}
                >
                  CANCEL
                </a>
                <button
                  className="geo-btn geo-btn--secondary geo-btn--caps "
                  onClick={() => handleConfirm()}
                  style={{
                    padding: "12px 30px",
                    marginLeft: "15px",
                    display: "flex"
                  }}
                  disabled={loading || !prompt}
                >
                  {" "}
                  YES
                  {loading && (
                    <div className="loading-spinner" style={{ marginLeft: 10 }}>
                      <span className="fa fa-spinner fa-spin"></span>
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade in" />
    </div>
  );
};

export default ConfirmationPopup;
